<template>
  <div v-redirect-if-no-permission:PERSONAL_VOUCHERS :key="switch1">
    <loading-component :value="loading" />
    <DataTable ref="dataTable" :url="'voucher'" :enable-edit="false" :enable-add="false" :enable-delete="false"
      :formatter="formatters" :actions-extra-main="actionsExtraMain" perPage="10" :fields-hidden-main="['max_redemption','use_times','used_amount']"
      :titles="titles" :title='$t("vouchersPage.pageTitlePersonalExpired")' :initial-url-search-params="tableParams" />

    <v-dialog v-model="dialog" max-width="500px">
      <v-card style="padding: 10px;">
        <v-card-title>
          <span class="headline">
            {{ $t("vouchersPage.addVoucherTitle") }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-form :key="formKey" ref="addForm">
            <v-text-field :rules="[rules.required]" :label='$t("vouchersPage.title")' type="text" v-model="model.title" />
            <v-text-field :rules="[rules.required]" :label='$t("vouchersPage.code")' type="text" v-model="model.code" />
            <v-select :label='$t("vouchersPage.discountType")' :items="discountTypeItems" :rules="[rules.required]"
              v-model="model.discount_type" />
            <v-text-field :rules="[rules.required, rules.number]" :label='$t("vouchersPage.amount")' type="number" v-model="model.amount" />

            <choose-date :label='$t("vouchersPage.startDate")' v-model="model.start_date"></choose-date>
            <choose-date :label='$t("vouchersPage.endDate")' v-model="model.end_date"></choose-date>

            <v-text-field :rules="[rules.required, rules.number]" :label='$t("vouchersPage.maxRedemption")' type="number"
              v-model="model.max_redemption" />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" style="width: 50%;" :loading="dialogLoading" flat @click="addVoucher()">{{ $t("vouchersPage.add") }}</v-btn>
          <v-btn color="primary" style="width: 50%;" :loading="dialogLoading" flat
            @click="dialog = false">{{ $t("vouchersPage.cancel") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";
import LoadingComponent from "@/components/LoadingComponent";
import ChooseDate from "@/components/monaco/input/ChooseDate";

export default {
  name: "PersonalExpiredVouchers",
  title() {
    return this.$t("vouchersPage.pageTitlePersonalExpired");
  },
  components: {
    LoadingComponent,
    DataTable,
    ChooseDate
  },
  data() {
    return {
      formKey: 0,
      rules: {
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("vouchersPage.ruleLength", { len }),
        required: (v) => !!v || this.$t("vouchersPage.ruleRequired"),
        number: (v) => /^\d+(\.\d+)?$/.test(v) || this.$t("vouchersPage.ruleNumber")
      },
      loading: false,
      dialogLoading: false,
      dialog: false,
      selectedCaptain: null,
      model: {
        title: "",
        code: "",
        discount_type: "PERCENTAGE",
        amount: "",
        start_date: "",
        end_date: "",
        type: "PROMOTIONAL",
        max_redemption: null
      },
      switch1: null,
    };
  },

  computed: {
    formatters() {
      return {
        created_at(value) {
          return value ? formatCompanyTime(value, "YYYY-MM-DD") : "";
        },
        admin_name: (value) => value || this.$t("vouchersPage.system"),
        discount_type: (value) =>
          value == "PERCENTAGE" ? "%" : this.$t("vouchersPage.discountTypeFixed"),
        amount: (value, item) => {
          // Voucher amount is MONEY only when discount type is FIXED; for
          // PERCENTAGE it is a percent value and must not be scaled. Inline the
          // ÷100 (no `this`) so it is robust to how DataTable invokes formatters.
          if (item && item.discount_type === "PERCENTAGE") return value;
          if (value == null || value === "") return "—";
          return new Intl.NumberFormat("en", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value) / 100);
        },
        type: (value) =>
          value == "DEDICATED"
            ? this.$t("vouchersPage.typeDedicated")
            : this.$t("vouchersPage.typeOnboarding"),
        active(val) {
          return `
                        <i class="v-icon fa ${val ? "fa-check" : "fa-close"
            }"></i>
                        `;
        },
      };
    },
    discountTypeItems() {
      return [
        { text: this.$t("vouchersPage.discountTypePercentage"), value: "PERCENTAGE" },
        { text: this.$t("vouchersPage.discountTypeFixed"), value: "FIXED" },
      ];
    },
    titles() {
      return {
        id: "#",
        title: this.$t("vouchersPage.title"),
        code: this.$t("vouchersPage.code"),
        type: this.$t("vouchersPage.type"),
        discount_type: this.$t("vouchersPage.discountType"),
        amount: this.$t("vouchersPage.amount"),
        start_date: this.$t("vouchersPage.startDate"),
        end_date: this.$t("vouchersPage.endDate"),
        full_name: this.$t("vouchersPage.passenger"),
        admin_name: this.$t("vouchersPage.createdBy"),
        active: this.$t("vouchersPage.active"),
        created_at: this.$t("vouchersPage.creationDate")
      };
    },
    tableParams() {
      const params = new URLSearchParams();
      params.append("type", "PERSONAL");
      return params;
    },
    actionsExtraMain() {
      return {

      };
    },

  },
  watch: {

    dialog: function (val) {
      this.dialogLoading = false;
      if (val)
        this.formKey++;
      else
      this.resetModel();


    },
  },
  methods: {
    resetModel() {
      this.model = {
        title: "",
        code: "",
        discount_type: "PERCENTAGE",
        amount: "",
        start_date: "",
        end_date: "",
        type: "PROMOTIONAL",
        max_redemption: null
      };
    },
    addVoucher() {

      const form = this.$refs.addForm;
      if (!form.validate()) {
        return;
      }

      this.dialogLoading = true;
      // Amount is MONEY only for FIXED vouchers -> convert to stored units on
      // submit. For PERCENTAGE it is a percent value and must be sent as-is.
      const payload = {
        ...this.model,
        amount:
          this.model.discount_type === "PERCENTAGE"
            ? this.model.amount
            : this.toStoredAmount(this.model.amount),
      };
      this.axios
        .post(`voucher`, payload)
        .then(() => {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("vouchersPage.voucherAdded"),
            "green"
          );
           this.dialog = false;
          this.$refs.dataTable.getData();

        })
        .catch((err) => {
          this.dialogLoading = false;
          const errorMessage = (err.response && err.response.data && err.response.data.message)
            ? err.response.data.message
            : this.$t("vouchersPage.errorOccurred");
          window.getApp.$emit("SHOW_TOAST", errorMessage, "red");

        });
    },
  },
};
</script>

<style lang="scss" scoped>
.sbtn {
  float: inline-end;
  z-index: 1;
  margin-top: 20px;
  margin-inline-end: 20px;
  padding: 0px 45px;
}

.input {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 10px;

  label {
    font-size: 14px;
  }

  input {
    width: max-content;
    flex-grow: 1;
  }
}
</style>
